import pino from "pino";

function getLogLevel(): string {
  try {
    return (import.meta.env.VITE_LOG_LEVEL as string) || "info";
  } catch {
    return "info";
  }
}

const redactedPaths = [
  "email",
  "*.email",
  "password",
  "*.password",
  "token",
  "*.token",
  "ssn",
  "*.ssn",
  "phone",
  "*.phone",
  "creditCard",
  "*.creditCard",
  "apiKey",
  "*.apiKey",
];

/**
 * Structured logger with PII redaction. In the browser (Vite) pino falls
 * back to console output; redact still scrubs sensitive keys from objects.
 */
export const logger = pino({
  level: getLogLevel(),
  redact: {
    paths: redactedPaths,
    remove: true,
  },
});
